// extracted by mini-css-extract-plugin
export default {"jenga":"jenga_jenga__3gKYQ","item":"jenga_item__3aMqO","top-left":"jenga_top-left__DY-TY","top-right":"jenga_top-right__i5KyL","bottom":"jenga_bottom__2OxjR"};